import styled, { css } from 'styled-components';
import { withPrivacy } from 'components/atoms/private';

const Bar = styled.div``;

export const Primary = styled(Bar)``;

export const Secondary = styled(Bar)``;

export const Central = styled(Bar)``;

export const Hanger = styled(Bar)``;

interface Props {
  layer?: number;
}

const ActionBar = styled.div<Props>`
  background: var(--action-bar-background);
  display: flex;
  height: var(--rte-action-bar-height);
  overflow: hidden;
  transition: height var(--animation-duration-medium) ease-in;
  align-items: center;

  ${({ layer }) =>
    layer != null
      ? css`
          z-index: var(--zindex-layer-${`0${layer}`});
        `
      : css`
          z-index: var(--zindex-modal-lowest);
        `}

  & {
    --action-bar-background: var(--coolest-gray-10);
    --action-bar-height: 2rem;
  }

  ${Primary},
  ${Secondary},
  ${Central} {
    align-items: center;
    display: flex;
    flex: 1;
  }

  ${Primary} {
    justify-content: flex-start;
  }

  ${Secondary} {
    justify-content: flex-end;
  }

  ${Central} {
    justify-content: center;
  }

  ${Bar} .ant-btn-icon-only {
    width: 2rem;
    min-width: 2rem;
    height: 2rem;
  }

  ${Hanger} {
    position: absolute;
    right: -3rem;
  }
`;

const PrivateStyles = css`
  --action-bar-background: var(--private-02);
`;

export const Component = withPrivacy(ActionBar, PrivateStyles);
